<button *ngIf="form && checkComponent()" matTooltip="addSignaler" type="button" [disabled]="disabledButton()"
    class="my-bounce btn closeRequestButton mx-2 clsButtonDefault" (click)="openModal()">
    {{ 'LABEL.addSignaler' | translate }}
</button>